import {
  clearError,
  startLoading,
  stopLoading,
  saveErrorMsg,
} from '../../helpers/api/meta'
import { handleError } from '../error'
import { getSearchResult } from '../../helpers/api/api' 

export const SEARCH_STARTED = 'SEARCH_STARTED'
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS'
export const SEARCH_FAILURE = 'SEARCH_FAILURE'
export const SEARCH_CLEAR = 'SEARCH_CLEAR'

export const searchStarted = () => ({ type: SEARCH_STARTED })
export const searchSuccess = data => ({ type: SEARCH_SUCCESS, data: data.value })
export const searchFailure = error => ({ type: SEARCH_FAILURE, error })
export const searchClear = () => ({ type: SEARCH_CLEAR })

const messages = {
  id: 'searchUser',
  failure: 'User search failed.',
}

const initialState = {
  list: [],
  loading: false,
  error: {}
}

export const callSearchStart = (val) => (dispatch) => {
  dispatch(searchStarted())

  return getSearchResult(val)
    .then((success) => {
      dispatch(searchSuccess(success))
    })
    .catch((error) => {
      dispatch(searchFailure())
      handleError(dispatch, error, messages.id, messages.failure)
      throw error;
    })
}

export const callSearchClear = () => (dispatch) => {
  dispatch(searchClear())
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case SEARCH_STARTED: {
      return startLoading(clearError(state))
    }
    case SEARCH_SUCCESS: {
      return { ...state, loading: false, list: action.data };
    }
    case SEARCH_FAILURE: {
      return saveErrorMsg(stopLoading(state), action, messages.failure)
    }
    case SEARCH_CLEAR: {
      return stopLoading(clearError(state))
    }
    default:
      return state
  }
}